// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  flex: 1 1;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.dashboard__head-text {
  float: left;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  color: #333333;
}
.dashboard__head-buttons {
  display: flex;
  float: right;
  padding: 3px;
}
.dashboard__head-buttons button {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashboard__head-button__active {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  padding: 9px 10px 8px 10px;
  border: 0px;
  border-radius: 8px;
  cursor: pointer;
  background: white;
}
.dashboard__head-button__inactive {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #505054;
  padding: 10px;
  border: 0px;
  border-radius: 8px;
  cursor: pointer;
  background: #e1e1e1;
}
.dashboard__date-input {
  width: 210px;
}
.dashboard__today-button {
  margin-left: 10px;
  margin-right: 10px;
}
.dashboard__button-list {
  background: #e1e1e1;
  padding: 1px;
  height: 39px;
  border-radius: 8px;
}

.dashboard-row {
  margin-top: 15px;
  display: flex;
}
.dashboard-row__col1 {
  width: 60%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  align-items: stretch;
  width: 100%;
}
.dashboard-row__col2 {
  display: flex;
  width: 40%;
  border: 1.5px solid #4aae9e;
  margin-left: 10px;
  border-radius: 16px;
  background: white;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
}

.card {
  height: 132px;
  border-radius: 16px;
  cursor: pointer;
  padding-left: 5%;
  background: white;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
}
.card__card-text {
  padding-top: 30px;
  padding-left: 10px;
}
.card__card-text__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #999999;
}
.card__card-text__number {
  margin-top: 20px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}

.card:hover {
  cursor: pointer;
}

.arrows__left {
  border: 1px solid #e9e9e9;
  height: 40px;
  width: 40px;
  border-radius: 8px;
  margin-right: 10px;
  cursor: pointer;
  background: #ffffff;
}
.arrows__right {
  border: 1px solid #e9e9e9;
  height: 40px;
  width: 40px;
  border-radius: 8px;
  margin-left: 10px;
  cursor: pointer;
  background: #ffffff;
}

.dashboard-stats {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.dashboard-stats__content {
  flex: 1 1;
  align-items: center;
  padding-left: 20px;
  padding-top: 5px;
  padding-bottom: 20px;
  display: flex;
  cursor: pointer;
}
.dashboard-stats__head {
  padding-top: 20px;
  padding-left: 20px;
  padding-bottom: 20px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  align-items: center;
  color: #333333;
}
.dashboard-stats__head__span {
  color: #49ae9e;
}
.dashboard-stats__text {
  margin-left: 10px;
}
.dashboard-stats__text__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #333333;
}
.dashboard-stats__text__body {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  color: #999999;
}

.briefcase {
  background: #eff0f0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: relative;
}
.briefcase__image {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 4px;
}

.business-management {
  margin-top: 60px;
}
.business-management__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  color: #333333;
}
.business-management__content {
  display: flex;
  margin-top: 30px;
}
.business-management__left-col {
  width: 33%;
  background: #f0f8f6;
  border-radius: 16px;
  margin-right: 10px;
  display: flex;
  padding: 30px;
  cursor: pointer;
  background: white;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
}
.business-management__center-col {
  width: 33%;
  background: #f4f8fe;
  border-radius: 16px;
  margin-right: 10px;
  display: flex;
  padding: 30px;
  cursor: pointer;
  background: white;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
}
.business-management__right-col {
  width: 33%;
  background: #fef5dc;
  border-radius: 16px;
  display: flex;
  padding: 30px;
  cursor: pointer;
  background: white;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
}

.pie-chart__text {
  width: 75%;
}
.pie-chart__text__head {
  display: flex;
  align-items: center;
  font-size: 16px;
}
.pie-chart__text__numerator {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #505054;
}
.pie-chart__text__denominator {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #999999;
}

.pie-chart-media {
  height: 100%;
  width: 200px;
  margin-left: auto;
}
.pie-chart-media__chart {
  padding: 5px;
}
.pie-chart-media__value {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #49ae9e;
}
.pie-chart-media__percentage {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
}
.pie-chart-media__text-color1 {
  color: #49ae9e;
}
.pie-chart-media__text-color2 {
  color: #fd966c;
}
.pie-chart-media__text-color3 {
  color: #fed159;
}

.dashboard-row3 {
  display: flex;
  margin-top: 40px;
  width: 100%;
  height: 100%;
  justify-content: space-between;
}
.dashboard-row3__col1 {
  display: flex;
  padding: 2%;
  width: 66.5%;
  flex-direction: column;
  border-radius: 16px;
  background: #ffffff;
}
.dashboard-row3__col2 {
  display: flex;
  flex-direction: column;
  padding: 2%;
  width: 32.8%;
  height: 100%;
  border-radius: 16px;
  background: #ffffff;
}

.worklog {
  display: flex;
  height: 264px;
  flex-direction: column;
}
.worklog__journal {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.worklog__empty-worklog {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}
.worklog__empty-worklog__text {
  font-size: 16px;
  color: #c1c1c1;
}
.worklog__item-top {
  display: flex;
}
.worklog__bottom-border {
  border-bottom: 1px solid #f2f2f2;
}
.worklog__worklog-item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
.worklog__worklog-item__staff {
  align-items: center;
  align-content: center;
  display: flex;
  margin-left: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #505054;
}
.worklog__worklog-item__date {
  align-items: center;
  align-content: center;
  display: flex;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
  color: #999999;
  margin-left: 10px;
}
.worklog__profileimage {
  align-items: center;
  align-content: center;
  display: flex;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  object-fit: cover;
}
.worklog__worklog-item-text {
  margin-left: 10px;
}
.worklog__worklog-item-text__text {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #1c1c1c;
}
.worklog__table-row {
  display: flex;
  height: 66px;
  align-items: center;
}
.worklog__table-head {
  padding-bottom: 15px;
  display: flex;
  border-bottom: 1.5px solid #333333;
}
.worklog__table-head__instrictions-active {
  display: flex;
  padding-right: 20px;
  cursor: pointer;
}
.worklog__table-head__instrictions-active__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
  margin-right: 5px;
}
.worklog__table-head__instrictions-inactive {
  display: flex;
  padding-right: 20px;
  cursor: pointer;
}
.worklog__table-head__instrictions-inactive__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #c1c1c1;
  margin-right: 5px;
}
.worklog__table-head__special-notes-active {
  display: flex;
  padding-right: 20px;
  cursor: pointer;
}
.worklog__table-head__special-notes-active__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
  margin-right: 5px;
}
.worklog__table-head__special-notes-inactive {
  display: flex;
  padding-right: 20px;
  cursor: pointer;
}
.worklog__table-head__special-notes-inactive__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #c1c1c1;
  margin-right: 5px;
}
.worklog__table-head__view {
  margin-left: auto;
  margin-right: 0;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #999999;
  cursor: pointer;
}
.worklog__item {
  margin-right: 0;
}

.notice {
  display: flex;
  width: 100%;
  height: 264px;
  flex-direction: column;
}
.notice__journal {
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.notice__worklog-item {
  display: flex;
  width: 100%;
}
.notice__worklog-item-last {
  display: flex;
  padding-top: 15px;
  padding-bottom: 15px;
}
.notice__table-row {
  display: flex;
  width: 100%;
  height: 66px;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
}
.notice__table-head {
  padding-bottom: 15px;
  display: flex;
  border-bottom: 1.5px solid #333333;
}
.notice__table-head__instrictions {
  display: flex;
  padding-right: 20px;
}
.notice__table-head__instrictions__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
  margin-right: 5px;
}

.event {
  display: flex;
  background: #075453;
  border-radius: 16px;
  padding: 2%;
  margin-top: 40px;
}
.event__text {
  width: 70%;
  padding-top: 40px;
  padding-left: 40px;
}
.event__text__top {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #e5f4f2;
}
.event__text__bottom {
  margin-top: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  color: #ffffff;
}
.event__thankyou-image {
  width: 20%;
  margin-right: 80px;
}
.event__paginator {
  width: 10%;
  text-align: center;
  margin-top: 10%;
  padding-left: 40px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
}
.event__paginator__bck {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 14px;
  height: 28px;
  width: 44px;
  padding-top: 5px;
  color: #ffffff;
}
.event__paginator__span {
  color: #e1e1e1;
}

.carousel-section {
  margin-top: 40px;
}`, "",{"version":3,"sources":["webpack://./src/screens/dashboard/dashboard.scss"],"names":[],"mappings":"AAAA;EAEI,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAAJ;AAEI;EACI,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAR;AAGI;EACI,aAAA;EACA,YAAA;EACA,YAAA;AADR;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AADZ;AAMQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EAEA,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AALZ;AAQQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EAEA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAPZ;AAWI;EACI,YAAA;AATR;AAYI;EACI,iBAAA;EACA,kBAAA;AAVR;AAaI;EACI,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAXR;;AAeA;EACI,gBAAA;EACA,aAAA;AAZJ;AAcI;EACI,UAAA;EACA,aAAA;EACA,qCAAA;EACA,cAAA;EACA,oBAAA;EACA,WAAA;AAZR;AAeI;EACI,aAAA;EACA,UAAA;EACA,2BAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,4CAAA;AAbR;;AAiBA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,4CAAA;AAdJ;AAgBI;EACI,iBAAA;EACA,kBAAA;AAdR;AAgBQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAdZ;AAiBQ;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAfZ;;AAoBA;EACI,eAAA;AAjBJ;;AAsBI;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAnBR;AAsBI;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AApBR;;AAwBA;EACI,SAAA;EACA,aAAA;EACA,sBAAA;AArBJ;AAuBI;EACI,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;AArBR;AAwBI;EACI,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAtBR;AAwBQ;EACI,cAAA;AAtBZ;AA0BI;EACI,iBAAA;AAxBR;AA0BQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAxBZ;AA2BQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAzBZ;;AA8BA;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AA3BJ;AA6BI;EACI,kBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AA3BR;;AA+BA;EACI,gBAAA;AA5BJ;AA8BI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA5BR;AA+BI;EACI,aAAA;EACA,gBAAA;AA7BR;AAgCI;EACI,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,4CAAA;AA9BR;AAiCI;EACI,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,4CAAA;AA/BR;AAkCI;EACI,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,4CAAA;AAhCR;;AAqCI;EACI,UAAA;AAlCR;AAoCQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAlCZ;AAqCQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAnCZ;AAsCQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AApCZ;;AAyCA;EACI,YAAA;EACA,YAAA;EACA,iBAAA;AAtCJ;AAwCI;EACI,YAAA;AAtCR;AAyCI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvCR;AA0CI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAxCR;AA2CI;EACI,cAAA;AAzCR;AA4CI;EACI,cAAA;AA1CR;AA6CI;EACI,cAAA;AA3CR;;AA+CA;EACI,aAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;AA5CJ;AA8CI;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AA5CR;AA+CI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AA7CR;;AAiDA;EACI,aAAA;EACA,aAAA;EACA,sBAAA;AA9CJ;AAgDI;EACI,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA9CR;AAiDI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AA/CR;AAiDQ;EACI,eAAA;EACA,cAAA;AA/CZ;AAmDI;EACI,aAAA;AAjDR;AAoDI;EACI,gCAAA;AAlDR;AAqDI;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;AAnDR;AAsDQ;EACI,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,iBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArDZ;AAwDQ;EACI,mBAAA;EACA,qBAAA;EACA,aAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EAEA,iBAAA;AAxDZ;AA4DI;EACI,mBAAA;EACA,qBAAA;EACA,aAAA;EAEA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AA3DR;AA8DI;EACI,iBAAA;AA5DR;AA8DQ;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA5DZ;AAgEI;EACI,aAAA;EACA,YAAA;EACA,mBAAA;AA9DR;AAiEI;EACI,oBAAA;EACA,aAAA;EACA,kCAAA;AA/DR;AAiEQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AA/DZ;AAiEY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AA/DhB;AAmEQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAjEZ;AAmEY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAjEhB;AAqEQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAnEZ;AAqEY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAnEhB;AAuEQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AArEZ;AAuEY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AArEhB;AAyEQ;EACI,iBAAA;EACA,eAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAxEZ;AA4EI;EACI,eAAA;AA1ER;;AA8EA;EACI,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AA3EJ;AA6EI;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA3ER;AA8EI;EACI,aAAA;EACA,WAAA;AA5ER;AA+EI;EACI,aAAA;EACA,iBAAA;EACA,oBAAA;AA7ER;AAgFI;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;AA9ER;AAiFI;EACI,oBAAA;EACA,aAAA;EACA,kCAAA;AA/ER;AAiFQ;EACI,aAAA;EACA,mBAAA;AA/EZ;AAiFY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AA/EhB;;AAqFA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAlFJ;AAoFI;EACI,UAAA;EACA,iBAAA;EACA,kBAAA;AAlFR;AAoFQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAlFZ;AAqFQ;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAnFZ;AAuFI;EACI,UAAA;EACA,kBAAA;AArFR;AAwFI;EACI,UAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAvFR;AAyFQ;EACI,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAvFZ;AA0FQ;EACI,cAAA;AAxFZ;;AA6FA;EACI,gBAAA;AA1FJ","sourcesContent":[".dashboard {\n\n    flex: 1;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n\n    &__head-text {\n        float: left;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 22px;\n        line-height: 32px;\n        color: #333333;\n    }\n\n    &__head-buttons {\n        display: flex;\n        float: right;\n        padding: 3px;\n\n        button {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n    }\n\n    &__head-button {\n        &__active {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 16px;\n            color: #333333;\n\n            padding: 9px 10px 8px 10px;\n            border: 0px;\n            border-radius: 8px;\n            cursor: pointer;\n            background: white;\n        }\n\n        &__inactive {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 16px;\n            color: #505054;\n\n            padding: 10px;\n            border: 0px;\n            border-radius: 8px;\n            cursor: pointer;\n            background: #e1e1e1;\n        }\n    }\n\n    &__date-input {\n        width: 210px;\n    }\n\n    &__today-button {\n        margin-left: 10px;\n        margin-right: 10px;\n    }\n\n    &__button-list {\n        background: #e1e1e1;\n        padding: 1px;\n        height: 39px;\n        border-radius: 8px;\n    }\n}\n\n.dashboard-row {\n    margin-top: 15px;\n    display: flex;\n\n    &__col1 {\n        width: 60%;\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        grid-gap: 10px;\n        align-items: stretch;\n        width: 100%;\n    }\n\n    &__col2 {\n        display: flex;\n        width: 40%;\n        border: 1.5px solid #4aae9e;\n        margin-left: 10px;\n        border-radius: 16px;\n        background: white;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n    }\n}\n\n.card {\n    height: 132px;\n    border-radius: 16px;\n    cursor: pointer;\n    padding-left: 5%;\n    background: white;\n    box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n\n    &__card-text {\n        padding-top: 30px;\n        padding-left: 10px;\n\n        &__text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            color: #999999;\n        }\n\n        &__number {\n            margin-top: 20px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #333333;\n        }\n    }\n}\n\n.card:hover {\n    cursor: pointer;\n}\n\n.arrows {\n\n    &__left {\n        border: 1px solid #e9e9e9;\n        height: 40px;\n        width: 40px;\n        border-radius: 8px;\n        margin-right: 10px;\n        cursor: pointer;\n        background: #ffffff;\n    }\n\n    &__right {\n        border: 1px solid #e9e9e9;\n        height: 40px;\n        width: 40px;\n        border-radius: 8px;\n        margin-left: 10px;\n        cursor: pointer;\n        background: #ffffff;\n    }\n}\n\n.dashboard-stats {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n\n    &__content {\n        flex: 1;\n        align-items: center;\n        padding-left: 20px;\n        padding-top: 5px;\n        padding-bottom: 20px;\n        display: flex;\n        cursor: pointer;\n    }\n\n    &__head {\n        padding-top: 20px;\n        padding-left: 20px;\n        padding-bottom: 20px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 22px;\n        align-items: center;\n        color: #333333;\n\n        &__span {\n            color: #49ae9e;\n        }\n    }\n\n    &__text {\n        margin-left: 10px;\n\n        &__head {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            color: #333333;\n        }\n\n        &__body {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n            align-items: center;\n            color: #999999;\n        }\n    }\n}\n\n.briefcase {\n    background: #eff0f0;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    position: relative;\n\n    &__image {\n        position: absolute;\n        margin: auto;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 4px;\n    }\n}\n\n.business-management {\n    margin-top: 60px;\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 22px;\n        line-height: 32px;\n        color: #333333;\n    }\n\n    &__content {\n        display: flex;\n        margin-top: 30px;\n    }\n\n    &__left-col {\n        width: 33%;\n        background: #f0f8f6;\n        border-radius: 16px;\n        margin-right: 10px;\n        display: flex;\n        padding: 30px;\n        cursor: pointer;\n        background: white;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n    }\n\n    &__center-col {\n        width: 33%;\n        background: #f4f8fe;\n        border-radius: 16px;\n        margin-right: 10px;\n        display: flex;\n        padding: 30px;\n        cursor: pointer;\n        background: white;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n    }\n\n    &__right-col {\n        width: 33%;\n        background: #fef5dc;\n        border-radius: 16px;\n        display: flex;\n        padding: 30px;\n        cursor: pointer;\n        background: white;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n    }\n}\n\n.pie-chart {\n    &__text {\n        width: 75%;\n\n        &__head {\n            display: flex;\n            align-items: center;\n            font-size: 16px;\n        }\n\n        &__numerator {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            color: #505054;\n        }\n\n        &__denominator {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            align-items: center;\n            color: #999999;\n        }\n    }\n}\n\n.pie-chart-media {\n    height: 100%;\n    width: 200px;\n    margin-left: auto;\n\n    &__chart {\n        padding: 5px;\n    }\n\n    &__value {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 28px;\n        line-height: 38px;\n        color: #49ae9e;\n    }\n\n    &__percentage {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n    }\n\n    &__text-color1 {\n        color: #49ae9e;\n    }\n\n    &__text-color2 {\n        color: #fd966c;\n    }\n\n    &__text-color3 {\n        color: #fed159;\n    }\n}\n\n.dashboard-row3 {\n    display: flex;\n    margin-top: 40px;\n    width: 100%;\n    height: 100%;\n    justify-content: space-between;\n\n    &__col1 {\n        display: flex;\n        padding: 2%;\n        width: 66.5%;\n        flex-direction: column;\n        border-radius: 16px;\n        background: #ffffff;\n    }\n\n    &__col2 {\n        display: flex;\n        flex-direction: column;\n        padding: 2%;\n        width: 32.8%;\n        height: 100%;\n        border-radius: 16px;\n        background: #ffffff;\n    }\n}\n\n.worklog {\n    display: flex;\n    height: 264px;\n    flex-direction: column;\n\n    &__journal {\n        flex: 1;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    &__empty-worklog {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 100%;\n        text-align: center;\n\n        &__text {\n            font-size: 16px;\n            color: #c1c1c1;\n        }\n    }\n\n    &__item-top {\n        display: flex;\n    }\n\n    &__bottom-border {\n        border-bottom: 1px solid #f2f2f2;\n    }\n\n    &__worklog-item {\n        display: flex;\n        width: 100%;\n        align-items: center;\n        justify-content: space-between;\n        // border-bottom: 1px solid #f2f2f2;\n\n        &__staff {\n            align-items: center;\n            align-content: center;\n            display: flex;\n            margin-left: 10px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 12px;\n            line-height: 18px;\n            color: #505054;\n        }\n\n        &__date {\n            align-items: center;\n            align-content: center;\n            display: flex;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n            text-align: right;\n            color: #999999;\n\n            margin-left: 10px;\n        }\n    }\n\n    &__profileimage {\n        align-items: center;\n        align-content: center;\n        display: flex;\n\n        border-radius: 50%;\n        height: 30px;\n        width: 30px;\n        object-fit: cover;\n    }\n\n    &__worklog-item-text {\n        margin-left: 10px;\n\n        &__text {\n            font-family: 'Inter';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            color: #1c1c1c;\n        }\n    }\n\n    &__table-row {\n        display: flex;\n        height: 66px;\n        align-items: center;\n    }\n\n    &__table-head {\n        padding-bottom: 15px;\n        display: flex;\n        border-bottom: 1.5px solid #333333;\n\n        &__instrictions-active {\n            display: flex;\n            padding-right: 20px;\n            cursor: pointer;\n\n            &__text {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 24px;\n                color: #333333;\n                margin-right: 5px;\n            }\n        }\n\n        &__instrictions-inactive {\n            display: flex;\n            padding-right: 20px;\n            cursor: pointer;\n\n            &__text {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 24px;\n                color: #c1c1c1;\n                margin-right: 5px;\n            }\n        }\n\n        &__special-notes-active {\n            display: flex;\n            padding-right: 20px;\n            cursor: pointer;\n\n            &__text {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 24px;\n                color: #333333;\n                margin-right: 5px;\n            }\n        }\n\n        &__special-notes-inactive {\n            display: flex;\n            padding-right: 20px;\n            cursor: pointer;\n\n            &__text {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 24px;\n                color: #c1c1c1;\n                margin-right: 5px;\n            }\n        }\n\n        &__view {\n            margin-left: auto;\n            margin-right: 0;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #999999;\n            cursor: pointer;\n        }\n    }\n\n    &__item {\n        margin-right: 0;\n    }\n}\n\n.notice {\n    display: flex;\n    width: 100%;\n    height: 264px;\n    flex-direction: column;\n\n    &__journal {\n        color: #333333;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    &__worklog-item {\n        display: flex;\n        width: 100%;\n    }\n\n    &__worklog-item-last {\n        display: flex;\n        padding-top: 15px;\n        padding-bottom: 15px;\n    }\n\n    &__table-row {\n        display: flex;\n        width: 100%;\n        height: 66px;\n        align-items: center;\n        border-bottom: 1px solid #f2f2f2;\n    }\n\n    &__table-head {\n        padding-bottom: 15px;\n        display: flex;\n        border-bottom: 1.5px solid #333333;\n\n        &__instrictions {\n            display: flex;\n            padding-right: 20px;\n\n            &__text {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 24px;\n                color: #333333;\n                margin-right: 5px;\n            }\n        }\n    }\n}\n\n.event {\n    display: flex;\n    background: #075453;\n    border-radius: 16px;\n    padding: 2%;\n    margin-top: 40px;\n\n    &__text {\n        width: 70%;\n        padding-top: 40px;\n        padding-left: 40px;\n\n        &__top {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 16px;\n            line-height: 22px;\n            color: #e5f4f2;\n        }\n\n        &__bottom {\n            margin-top: 10px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 22px;\n            line-height: 32px;\n            color: #ffffff;\n        }\n    }\n\n    &__thankyou-image {\n        width: 20%;\n        margin-right: 80px;\n    }\n\n    &__paginator {\n        width: 10%;\n        text-align: center;\n        margin-top: 10%;\n        padding-left: 40px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n\n        &__bck {\n            background: rgba(0, 0, 0, 0.3);\n            border-radius: 14px;\n            height: 28px;\n            width: 44px;\n            padding-top: 5px;\n            color: #ffffff;\n        }\n\n        &__span {\n            color: #e1e1e1;\n        }\n    }\n}\n\n.carousel-section {\n    margin-top: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
